import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6c85869c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=6c85869c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85869c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c85869c')) {
      api.createRecord('6c85869c', component.options)
    } else {
      api.reload('6c85869c', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6c85869c&scoped=true&", function () {
      api.rerender('6c85869c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UIComponents/Header.vue"
export default component.exports